import type { HeadPose, FaceLandmark } from '../types';

const LANDMARKS = {
  NOSE_TIP: 1,
  CHIN: 152,
  LEFT_EYE: 33,
  RIGHT_EYE: 263,
  LEFT_MOUTH: 61,
  RIGHT_MOUTH: 291,
};

export function estimateHeadPose(landmarks: FaceLandmark[]): HeadPose {
  if (landmarks.length < 300) {
    return { yaw: 0, pitch: 0, roll: 0 };
  }

  const nose = landmarks[LANDMARKS.NOSE_TIP];
  const chin = landmarks[LANDMARKS.CHIN];
  const leftEye = landmarks[LANDMARKS.LEFT_EYE];
  const rightEye = landmarks[LANDMARKS.RIGHT_EYE];
  const leftMouth = landmarks[LANDMARKS.LEFT_MOUTH];
  const rightMouth = landmarks[LANDMARKS.RIGHT_MOUTH];

  if (!nose || !chin || !leftEye || !rightEye || !leftMouth || !rightMouth) {
    return { yaw: 0, pitch: 0, roll: 0 };
  }

  const eyeMidX = (leftEye.x + rightEye.x) / 2;
  const noseToEyeDelta = nose.x - eyeMidX;
  const eyeDistance = Math.abs(rightEye.x - leftEye.x);
  const yaw = (noseToEyeDelta / eyeDistance) * 100;

  const eyeMidY = (leftEye.y + rightEye.y) / 2;
  const noseToChinDist = chin.y - nose.y;
  const noseToEyeDist = nose.y - eyeMidY;
  const pitch = (noseToEyeDist / noseToChinDist) * 80;

  const eyeLineAngle = Math.atan2(
    rightEye.y - leftEye.y,
    rightEye.x - leftEye.x,
  );
  const mouthLineAngle = Math.atan2(
    rightMouth.y - leftMouth.y,
    rightMouth.x - leftMouth.x,
  );
  const rollRad = (eyeLineAngle + mouthLineAngle) / 2;
  const roll = (rollRad * 180) / Math.PI;

  return {
    yaw: Math.round(yaw * 10) / 10,
    pitch: Math.round(pitch * 10) / 10,
    roll: Math.round(roll * 10) / 10,
  };
}
